import Vue from 'vue'
import FeatureMarkerLayer from './layers/marker/FeatureMarkerLayer'
import { newDom, addStyle } from './domUtil'
import { isNumber } from 'util'

/**
 * 图片maker合集
 * maker聚合(图片类型，用于poi搜索合集)
 */
export default function getFeatureMarkerLayer(map, title, opt_options) {
    return new FeatureMarkerLayer(map, title, opt_options)
}

/**
 * 新建一个Icon
 * @param {*} param0
 * @return {HTMLElement}
 */
function newIcon({
    // Icon 大小
    size: [width, height],

    // 图标地址
    imageUrl,
    // 图片偏移
    imageOffset = [0, 0],
    // 图片大小（一般不设置）
    imageSize = 'cover'
}) {
    const checkpx = arg => {
        return arg + (isNumber(arg) ? 'px' : '')
    }
    // 默认显示
    const icon = newDom(`<div></div>`)
    addStyle(icon, {
        width: checkpx(width),
        height: checkpx(height),
        backgroundImage: `url(${imageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: imageSize,
        backgroundPositionX: checkpx(imageOffset[0]),
        backgroundPositionY: checkpx(imageOffset[1])
    })
    return icon
}

/**
 * 新建通用Marker
 * @param {HTMLElement} el
 * @param {*} opt_options
 */
function newMarker(el, opt_options) {
    const options = buildMarkerOptions(
        el.style.width,
        el.style.height,
        opt_options
    )
    return new mapboxgl.Marker(el, options)
}

/**
 * 新建一个可选中的图片marker
 * @param {*} param0
 * @param {*} opt_options
 */
function newMarker2(
    {
        // 未选中参数
        unSelectOption,
        // 选中切换显示参数
        selectOption
    },
    opt_options
) {
    const container = newDom(`<div class="img-marker"></div>`)

    let unselect

    // 默认显示
    if (unSelectOption) {
        unselect = newIcon(unSelectOption)
    } else {
        unselect = newIcon({ ...arguments[0] })
    }
    container.appendChild(unselect)

    // 选中显示
    if (selectOption) {
        unselect.setAttribute('select', 'false')

        const select = newIcon(selectOption)
        select.setAttribute('select', 'true')

        container.appendChild(select)
    }

    const options = buildMarkerOptions(
        unselect.style.width,
        unselect.style.height,
        opt_options
    )
    return new mapboxgl.Marker(container, options)
}

/**
 * 生成marker参数
 * @param {*} width
 * @param {*} height
 * @param {*} opt_options
 */
function buildMarkerOptions(width, height, opt_options) {
    let { offset = [0, 0], position } = opt_options || {}
    if (position) {
        const x = parseInt(parseFloat(width) / 2) || 0
        const y = parseInt(parseFloat(height) / 2) || 0

        let offsetX = offset[0]
        let offsetY = offset[1]

        /**
         * @type {Array}
         */
        const pos = position.split('-')
        while (pos.length) {
            const i = pos.shift()
            switch (i) {
                case 'top':
                    offsetY += y
                    break
                case 'bottom':
                    offsetY += -y
                    break
                case 'left':
                    offsetX += x
                    break
                case 'right':
                    offsetX += -x
                    break
            }
        }
        offset = [offsetX, offsetY]
    }
    // 构建新的options
    let options = { ...opt_options, offset }
    delete options.position

    return options
}

/**
 * 根据配置绑定Marker初始化参数
 * @param {Array} features
 * @param {Object} config
 * @param {String} direction row | column
 */
function bindMarkerOption(features, config, direction = 'row') {
    const {
        imgUrl,
        imgSize,
        markerSize,
        unselectStartPos,
        selectStartPos
    } = config

    for (let i = 0; i < features.length; i++) {
        let feature = features[i]

        const [width, height] = markerSize

        // 基础参数
        const baseOpt = {
            size: markerSize,
            imageUrl: imgUrl,
            imageSize: imgSize
        }
        feature.attributes.markeroptions = {}
        // 默认
        feature.attributes.markeroptions.unSelectOption = {
            ...baseOpt,
            imageOffset:
                direction === 'row'
                    ? [
                          `-${width * i + unselectStartPos[0]}px`,
                          `-${unselectStartPos[1]}px`
                      ]
                    : [
                          `-${unselectStartPos[0]}px`,
                          `-${height * i + unselectStartPos[1]}px`
                      ]
        }
        // 选中
        if (selectStartPos) {
            feature.attributes.markeroptions.selectOption = {
                ...baseOpt,
                imageOffset:
                    direction === 'row'
                        ? [
                              `-${width * i + selectStartPos[0]}px`,
                              `-${selectStartPos[1]}px`
                          ]
                        : [
                              `-${selectStartPos[0]}px`,
                              `-${height * i + selectStartPos[1]}px`
                          ]
            }
        }
    }
    return features
}
/**
 * 根据配置绑定Marker初始化参数
 * @param {Array} features
 * @param {Object} config
 * @param {String} direction row | column
 */
function bindMarkerOptionTask(features, config, direction = 'row') {
    const {
        imageUrl,
        markerSize,
        selectStartPos
    } = config

    for (let i = 0; i < features.length; i++) {
        let feature =  features[i]

        const [width, height] = markerSize
        // 基础参数
        const baseOpt = {
            size: markerSize,
            imageUrl: imageUrl,
/*            imageSize: imgSize*/
        }
        feature.attributes.markeroptions = {}
        // 默认
        feature.attributes.markeroptions.unSelectOption = {
            ...baseOpt,
            imageOffset:[0,0]
        }
        // 选中
        if (selectStartPos) {
            feature.attributes.markeroptions.selectOption = {
                ...baseOpt,
                imageOffset: [0,0]

            }
        }
    }
    return features
}

/**
 * 新建vue组件marker
 * @param {*} vueComp vue组件
 * @param {*} param1
 */
function newVueMarker(vueComp, { properties, opt_options } = {}) {
    const _props = properties || {}
    const Instance = new Vue({
        render(h) {
            return h(vueComp, {
                props: _props
            })
        }
    })
    let component = Instance.$mount()

    const marker = new mapboxgl.Marker(component.$el, opt_options)
    marker.remove = function() {
        if (this._map) {
            component.$destroy()
            component = null
        }
        return marker.__proto__.remove.call(this)
    }
    return marker
}

/**
 * 新建vue组件popup
 * @param {*} vueComp vue组件
 * @param {*} param1
 */
function newVuePopup(vueComp, { properties, opt_options = {} } = {}) {
    const _props = properties || {}

    const Instance = new Vue({
        render(h) {
            return h(vueComp, {
                props: _props
            })
        }
    })
    let component = Instance.$mount()

    const config = Object.assign(
        {},
        {
            anchor: 'bottom',
            showArrow: false,
            closeOnClick: false,
            closeButton: false
        },
        opt_options
    )
    const popup = new mapboxgl.Popup(config)
    popup.setDOMContent(component.$el)
    popup.remove = function() {
        if (this._map) {
            component.$destroy()
            component = null
        }
        return popup.__proto__.remove.call(this)
    }
    return popup
}

export {
    newIcon,
    newMarker,
    newMarker2,
    bindMarkerOption,
    newVueMarker,
    newVuePopup,
    bindMarkerOptionTask
}
